import { render, staticRenderFns } from "./dealInfo.vue?vue&type=template&id=32d34ca7&scoped=true"
import script from "./dealInfo.vue?vue&type=script&lang=js"
export * from "./dealInfo.vue?vue&type=script&lang=js"
import style0 from "./dealInfo.vue?vue&type=style&index=0&id=32d34ca7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d34ca7",
  null
  
)

export default component.exports